import { Column } from 'elc-grid';
import styled from 'styled-components';
import { ContentSpacing } from 'elc-base-theme';

export const ShadeContainer = styled(Column)`
    padding-left: 0;
    overflow-y: auto;
    max-height: 200px;

    [dir='rtl'] & {
        padding-right: 0;
    }
`;

export const AlignedWrapper = styled.div`
    display: inline-block;
    vertical-align: middle;
    margin: 0 ${ContentSpacing.space8};
`;

export const ShadesWrapper = styled.div`
    margin: 0 ${ContentSpacing.space4};
`;
